import React, { useCallback } from 'react';
import Loading from 'components/Loading';
import cn from 'classnames';
import RelativePortal from 'components/RelativePortal';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import { routeMap } from '../../../../router';
import config from 'config';
import styles from './LogoutLink.module.scss';

const LogoutLink = ({
  onClick,
  setLogout,
  userLogout,
  route,
  className,
  title,
  children,
  logout,
}) => {
  const loading = logout.get('loading');

  const handleClick = useCallback(() => {
    if (config.isInspectorArm) {
      return;
    }

    if (route === routeMap.ndfl3) {
      setLogout(true);
      return;
    }

    if (onClick) {
      onClick();
    }

    userLogout();
  }, [onClick, setLogout, userLogout, route, config]);

  const renderPortal = () => {
    return (
      <RelativePortal>
        <Loading hasContainer={true} isLight={true} />
      </RelativePortal>
    );
  };

  return (
    <>
      <a
        className={cn([className, { [styles.disabled]: config.isInspectorArm }])}
        title={title}
        onClick={handleClick}
      >
        {children}
      </a>

      {loading ? renderPortal() : null}
    </>
  );
};

LogoutLink.propTypes = {
  logout: PropTypes.instanceOf(Map),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  route: PropTypes.string,
  onClick: PropTypes.func,
  setLogout: PropTypes.func,
  userLogout: PropTypes.func,
};

export default React.memo(LogoutLink);
